import { render, staticRenderFns } from "./SmallFeed.vue?vue&type=template&id=5cb8a6b8&"
import script from "./SmallFeed.vue?vue&type=script&lang=js&"
export * from "./SmallFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports